import { scrollToSection } from "./scrollToSection";

export const scrollToCurrentStep = (sectionRef) => {
  const curStep = sectionRef.current?.closest('[class*="app-ai-quote-step"]');

  if (curStep) {
    const newTop = window?.scrollY + curStep.getBoundingClientRect().top - 170;
    scrollToSection(newTop);
  }
};
